import { useFeatureFlagEnabled, useFeatureFlagPayload } from '@posthog/react/slim';
import { isUndefined } from 'lodash-es';

import { useFeatureFlagCookieData } from './use-feature-flag-cookie-data';

export const useSingleVariantData = <T>(featureFlagName: string): T | undefined => {
  const isFeatureEnabled = useFeatureFlagEnabled(featureFlagName);
  const postHogPayload = useFeatureFlagPayload(featureFlagName) as T;

  const { cookieVariant: cookieEnabled, cookiePayload } = useFeatureFlagCookieData<T>(featureFlagName);

  // If the feature flag is not enabled, return the cookie payload of the feature flag (which is fetched in the Middleware).
  if (!isFeatureEnabled) return cookieEnabled ? cookiePayload : undefined;

  // If the feature flag is set in PostHog (i.e. PostHog is ready and the user has opted in), use the PostHog payload.
  if (!isUndefined(postHogPayload)) return postHogPayload;
  // If the feature flag is not set in PostHog, check the cookie if the feature flag is set there.
  if (cookieEnabled && !isUndefined(cookiePayload)) return cookiePayload;
  // If the feature flag is not set in the cookie, there's no default payload for single variant flags.
  return undefined;
};
